import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-bet",
  "use": "icon-bet-usage",
  "viewBox": "0 0 63 63",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 63 63\" id=\"icon-bet\"><path d=\"M51.1,55.82,35.85,40.6,20.63,55.82h1.26a1.46,1.46,0,0,1,1.48,1.5h0v4.19A1.47,1.47,0,0,1,21.89,63h-20A1.46,1.46,0,0,1,.47,61.52h0V57.32a1.46,1.46,0,0,1,1.45-1.5h13L4.56,45.43a2.35,2.35,0,0,1,0-3.44l0-.08L45.79.72a2.46,2.46,0,0,1,3.48,0l0,0L60.78,12.22a2.48,2.48,0,0,1,0,3.48L41.14,35.32,62.07,56.21a1.55,1.55,0,0,1,.46,1.11v4.19h0A1.48,1.48,0,0,1,61.05,63h-2.2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol